import { Autocomplete, AutocompleteChangeDetails, Button, Grid, TextField, Tooltip } from '@mui/material';
import _ from 'lodash';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CustomAccordion from '../CustomAccordion/CustomAccordion';
import TotalSummaryApi, { GetTotalSummaryParam } from './api/TotalSummaryApi';
import BaseResponse from '../../app/BaseResponse';
import Utility from '../../app/utility';
import { showLoading } from '../LoadingView/reducers/LoadingViewReducer';
import { TotalSummarySearchSelector, setTotalSummaryResults, setTriggerSearch, setYear } from './reducers/TotalSummarySearchReducer';
import TotalSummaryResult from './models/TotalSummaryResult';
import { getYears } from '../MyFixtures/MyFixtureSearch';

const TotalSummarySearch: React.FunctionComponent = () => {
    const dispatch = useDispatch();
    const TotalSummarySearchData = useSelector(TotalSummarySearchSelector);

    useEffect(() => {
        dispatch(showLoading(true));

        TotalSummaryApi.GetTotalSummary({
            year: TotalSummarySearchData.year
        } as GetTotalSummaryParam)
            .then((response: BaseResponse<TotalSummaryResult>) => {
                if (response.success) {
                    dispatch(setTotalSummaryResults(response.data));
                } else {
                    Utility.Alert.Error(response.message);
                }
            }).catch((error) => {
                Utility.Alert.Error(error);
            })
            .finally(() => {
                dispatch(showLoading(false));
            });
    }, [TotalSummarySearchData.triggerSearch])

    return (
        <>
            <CustomAccordion
                title="Search"
                className="TotalSummary-search-area"
                defaultOpen={true}>
                <Grid container>
                    <Grid xs={2} className="TotalSummary-button">
                        <Grid container>
                            <Tooltip title="Alt + W">
                                <Button
                                    fullWidth
                                    variant="contained"
                                    className="tonnage-search-save-button"
                                    onClick={() => {
                                        dispatch(setTriggerSearch((new Date()).getTime()));
                                    }}
                                >
                                    RUN SEARCH (w)
                                </Button>
                            </Tooltip>
                        </Grid>
                    </Grid>
                    <Grid xs={10}>
                        <Autocomplete
                            disableClearable={true}
                            fullWidth
                            options={getYears()}
                            renderInput={(params) => <TextField {...params} label="Year" />}
                            className='cargo-input-component'
                            getOptionLabel={(option: number) => {
                                return option.toString();
                            }}
                            value={TotalSummarySearchData.year}
                            onChange={(event: React.SyntheticEvent, value: number, reason: string, details?: AutocompleteChangeDetails<number> | undefined) => {
                                dispatch(setYear(value));
                            }}
                        />
                    </Grid>
                </Grid>
            </CustomAccordion>
        </>
    )
};

export default TotalSummarySearch;